import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import {
  getFormQuestionAttributeDefaultFacility,
  getFormQuestionAttributeDefaultFacilityOptions,
  getFormQuestionPrompt,
  setQuestionAttributeDefaultFacility,
} from "reduxSlices/formBuilderSlice"
import { ListSelect } from "shared/selects"
import InactiveOptionsItemRenderer from "shared/selects/InactiveOptionsItemRenderer"
import ContentRenderer from "./ContentRenderer"

const optionsFromList = (options) => options.map((opt) => (
  { label: opt.name, value: opt.id, active: opt.active }
))

const DefaultFacility = ({ sectionIndex, questionIndex }) => {
  const dispatch = useDispatch()

  const questionDefaultFacility = useSelector(getFormQuestionAttributeDefaultFacility({ sectionIndex, questionIndex }))
  const questionDefaultFacilityOptions = useSelector(getFormQuestionAttributeDefaultFacilityOptions({ sectionIndex, questionIndex }), isEqual)
  const questionPrompt = useSelector(getFormQuestionPrompt({ sectionIndex, questionIndex }))

  const {
    name: facilityName,
    nameInSentence: facilityNameInSentence,
  } = useCustomName(FACILITY_KEY)

  const updateDefaultFacility = (newDefaultFacilityId) => dispatch(setQuestionAttributeDefaultFacility({
    sectionIndex, questionIndex, newDefaultFacilityId,
  }))

  return (
    <>
      <div className="flex-center mb-4">
        <div className="font-medium">Default {facilityName}</div>
      </div>
      <ListSelect
        className="text-sm"
        clearable
        contentRenderer={ContentRenderer}
        itemRenderer={InactiveOptionsItemRenderer}
        onChange={updateDefaultFacility}
        options={questionDefaultFacilityOptions}
        optionsFromList={optionsFromList}
        style={{ height: "32px" }}
        value={questionDefaultFacility}
        label={`select default ${facilityNameInSentence} answer for question ${questionPrompt}`}
      />
    </>
  )
}

DefaultFacility.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default DefaultFacility
